import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
import $ from 'jquery';

class Sandbox extends Component {
  moveDown = () => {
    $.fn.fullpage.moveSectionDown();
  }
  render() {
    return (
      <div className="game-container">
        <div className="wrap">
          <iframe id="game-iframe" className="game-iframe" src="/game" frameBorder="0" width="360" height="640"></iframe>
        </div>
        <img src="/content-img/arrow-down.svg" alt="" className="arrow-down" onClick={this.moveDown}/>
      </div>
    );
  }
}

export default Sandbox;



// WEBPACK FOOTER //
// ./src/components/Game/pure.js